module.exports = __webpack_public_path__ + "assets/1f16639a69b79116545ac6a00127df4e.svg";